import { render, staticRenderFns } from "./PrintTableDisciplines.vue?vue&type=template&id=716a95b1&"
import script from "./PrintTableDisciplines.vue?vue&type=script&lang=js&"
export * from "./PrintTableDisciplines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports